// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import lodashGet from 'lodash/get'

import { ObjectList } from '../../../../../components'
import { WizardContext } from '../../../../../components/wizard/WizardContext'
import { renameKeys } from '../../../../../utils/common-utils'
import { isMSP } from '../../../../../utils/feature-flag-utils'
import { mspApplicationEnum } from '../../../../../utils/constants'
// import { getAuthorizationText } from '../../constants'

const ReviewAndCreate = () => {
  const { formValues } = useContext(WizardContext)
  const { t } = useTranslation(['iam'])

  const tempI18NKeys = isMSP()
    ? {
        general: {
          mspApplication: t(
            'sso_configurations.create_auth_policy_wizard.applies_to'
          ),
          policyType: t(
            'sso_configurations.create_auth_policy_wizard.domain_type'
          ),
          domain: t('domains.domain_single'),
          ssoConnections: t('sso_configurations.sso_connections_tab'),
          authorizationMode: t(
            'sso_configurations.create_auth_policy_wizard.authorization_mode'
          )
        },
        recoveryUser: {
          recoveryEmail: t(
            'iam:sso_profiles.view_edit_create.recovery_username'
          ),
          pocEmail: t('iam:sso_profiles.view_edit_create.recovery_email')
        }
      }
    : {
        general: {
          policyType: t(
            'sso_configurations.create_auth_policy_wizard.domain_type'
          ),
          domain: t('domains.domain_single'),
          ssoConnections: t('sso_configurations.sso_connections_tab'),
          authorizationMode: t(
            'sso_configurations.create_auth_policy_wizard.authorization_mode'
          )
        },
        recoveryUser: {
          recoveryEmail: t(
            'iam:sso_profiles.view_edit_create.recovery_username'
          ),
          pocEmail: t('iam:sso_profiles.view_edit_create.recovery_email')
        }
      }

  const getGeneralObject = () => {
    let mspApplicationValue
    if (isMSP()) {
      switch (lodashGet(formValues, 'general.mspApplication').toString()) {
        case `${mspApplicationEnum.MANAGED_ORGANIZATIONS}`:
          mspApplicationValue = t(
            'sso_configurations.create_auth_policy_wizard.all_customer_organizations'
          )
          break
        case `${mspApplicationEnum.ORG_WORKSPACES}`:
          mspApplicationValue = t(
            'sso_profiles.view_edit_create.msp_organization'
          )
          break
        case `${mspApplicationEnum.ORG_WORKSPACES},${mspApplicationEnum.MANAGED_ORGANIZATIONS}`:
          mspApplicationValue = t(
            'sso_configurations.create_auth_policy_wizard.msp_and_all'
          )
          break
        default:
          break
      }
    }
    return {
      mspApplication: mspApplicationValue,
      policyType: lodashGet(formValues, 'general.policyType'),
      domain: lodashGet(formValues, 'general.domain'),
      ssoConnections: lodashGet(formValues, 'general.ssoConnections'),
      authorizationMode: lodashGet(formValues, 'general.authorizationMode')
    }
  }

  const getRecoveryUserObject = () => {
    return {
      recoveryEmail: lodashGet(formValues, 'recovery_user.recoveryEmail'),
      pocEmail: lodashGet(formValues, 'recovery_user.pocEmail')
    }
  }

  const getFilteredObject = (obj, filteredValues = []) => {
    const filteredObjectValues = {}
    Object.entries(obj).forEach(([key, value]) => {
      if (filteredValues.includes(key)) {
        filteredObjectValues.id = { ...filteredObjectValues.id, [key]: value }
      }
    })
    return filteredObjectValues.id
  }

  const general = renameKeys(
    tempI18NKeys.general,

    getFilteredObject(getGeneralObject(), Object.keys(tempI18NKeys.general))
  )

  const recoveryUser = renameKeys(
    tempI18NKeys.recoveryUser,
    getFilteredObject(
      getRecoveryUserObject(),
      Object.keys(tempI18NKeys.recoveryUser)
    )
  )
  return (
    <Box gap="medium" pad={{ bottom: 'medium' }}>
      <ObjectList
        data={general}
        testId="review-general"
        title={t('iam:sso_profiles.view_edit_create.general')}
        showRuler={false}
      />
      <ObjectList
        data={recoveryUser}
        testId="review-recovery-user"
        title="Recovery user"
        showRuler={false}
      />
    </Box>
  )
}

export default ReviewAndCreate
